import client from './client';

const Report = {
  getReport(anketId) {
    return client.get(`/ankets/${anketId}/sb_report`);
  },
  updateReport(anketId, data) {
    return client.put(`/ankets/${anketId}/sb_report`, data);
  },
};

export default Report;
